import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import onIgnoreCache  from '../IgnoreCache';
import GetSalesmanLinkSite from '../components/HomePageNew/GetSalesmanLinkSite';
import ThemeDefault from '../theme-default';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      
    };
  }

  componentWillMount(){
   
  }
  

  render() {
    return (
      <MuiThemeProvider muiTheme={ThemeDefault}>
        <Container id="container_page">
          {this.props.children}
          {onIgnoreCache()}
          <GetSalesmanLinkSite />
        </Container>
      </MuiThemeProvider>
    );
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default App;



/** WEBPACK FOOTER **
 ** ./src/containers/App.js
 **/